<template>
    <Modal @cancel="cancel">
        <div class="astreinte-container" role="alertdialog" aria-labelledby="astreinte-title">
            <div class="titre-container">
                <p id="astreinte-title">
                    {{$t('modale.astreinte.titre')}}
                </p>
                <ReglePastille cle="demandeIntervention.astreinte" />
            </div>
            <div v-for='societeAstreinte in societesAstreinte' :key='societeAstreinte.societe'>
                <div class="text">
                    {{ societeAstreinte.societe }}
                </div>
                <div class="text">
                    {{ societeAstreinte.telephone }}
                </div>
            </div>
            <div class="text">
                {{$t('modale.astreinte.horaires')}}
            </div>
            <button class="close-btn" @click="cancel" :aria-label="$t('aria.fermer.modale')">
                <img class="close-icon" :src="closeIcon" alt="" aria-hidden="true" />
            </button>
        </div>
    </Modal>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import Modal from '@/components/ui-components/Modal.vue';
import { CoordonneesAstreinte } from '@/modules/Intervention/store/state';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    components: { Modal, ReglePastille },
    computed: {
        closeIcon(): void {
            return require('@/assets/img/close-black.svg');
        },
        societesAstreinte(): CoordonneesAstreinte[] {
            return this.$store.getters.getCoordonneesAstreinte;
        },
    },
    methods: {
        cancel(): void{
            this.$emit('cancel');
        }
    },
});
</script>

<style scoped>
.astreinte-container{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 375px;
    background-color: var(--white);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14),
    0 1px 5px rgba(0, 0, 0, 0.12);
    text-align: center;
    font-weight: 500;
    font-size: var(--font-size-low-medium);
    color: var(--color-principal);
    padding: 16px;
    gap: 8px;
}
.close-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
}
.close-icon {
    display: block;
}
.titre-container {
    margin: 15px;
    font-size: var(--font-size-low-large);
}
.text {
    margin: 5px;
}
</style>
